/**
 * Llamadas del editor de campos calculados al motor (vía proxy /api/engine/formula/*):
 * catálogo de funciones (se descarga una vez por sesión), validación y vista previa.
 */
import { engineErrorMessage, engineFetch } from './engineConfig';

let catalogPromise = null;

async function postJson(path, body, fallback) {
    const response = await engineFetch(path, { method: 'POST', body: JSON.stringify(body || {}) });
    if (!response.ok) throw new Error(await engineErrorMessage(response, fallback));
    return response.json();
}

/** Catálogo {categories, functions} del lenguaje; si falla se reintenta en la próxima llamada. */
export function loadFormulaCatalog() {
    if (!catalogPromise) {
        catalogPromise = postJson('/api/engine/formula/functions', {}, 'No se pudo cargar el catálogo de funciones.')
            .catch(error => {
                catalogPromise = null;
                throw error;
            });
    }
    return catalogPromise;
}

/**
 * Valida la fórmula sin leer datos. fields = [{name, type}].
 * Respuesta: {ok, error:{message,start,end,line,column}, type, level, lod, references, warnings}.
 */
export function validateFormula(formula, fields, { signal } = {}) {
    return engineFetch('/api/engine/formula/validate', {
        method: 'POST',
        body: JSON.stringify({ formula, fields }),
        signal
    }).then(async response => {
        if (!response.ok) throw new Error(await engineErrorMessage(response, 'No se pudo validar la fórmula.'));
        return response.json();
    });
}

/** Muestra del resultado sobre los datos reales (payload: fuente + formula, name, calculated_fields…). */
export function previewFormula(payload) {
    return postJson('/api/engine/formula/preview', payload, 'No se pudo calcular la vista previa.');
}
